import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../../../Components/CSS/TableStyle.css";
import Axios from "axios";
import { url } from "../../../../../../Config/Config";
import AddFeeForm from "../AddFeeForm/AddFeeForm";
import CustomDialogBox from "../../../../../../Components/CustomDialogBox/CustomDialogBox";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../../Redux/Actions/actions";

class FeeFormBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
      feeId: "",
      dialogOpen: false,
      notificationOpen: false,
    };
  }

  handleEdit = (feeId) => {
    this.setState({
      editStatus: true,
      feeId,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDialogOpen = (feeId) => {
    this.setState({
      dialogOpen: true,
      feeId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteFeeHead = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/student-fees/${this.props.studentFeeId}/fee/${this.state.feeId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (
        response.data.message ===
        "Fee deleted successfully from fee group of student"
      ) {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getStudentFee(this.props.studentFeeId);
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteFeeHead();
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return this.state.editStatus === false ? (
      <TableRow key={index}>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.feeTypeName}</TableCell>
        <TableCell align="center">{data.price}</TableCell>
        <TableCell align="center">
          {data.status ? "Paid" : "Not Paid"}
        </TableCell>
        <TableCell align="center">
          {data.discount ? data.discount : 0}
        </TableCell>
        <TableCell align="center">
          {data.remarks ? data.remarks : "N/A"}
        </TableCell>
        <TableCell align="center">
          <Tooltip
            arrow
            title="Edit"
            className={classes.tooltip}
            onClick={() => this.handleEdit(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            arrow
            title="Delete"
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteFeeHead}
        />
      </TableRow>
    ) : (
      <AddFeeForm
        editStatus={true}
        data={data}
        handleCancelEdit={this.handleCancelEdit}
        initialFeeGroup={this.props.initialFeeGroup}
        studentFeeId={this.props.studentFeeId}
        getStudentFee={this.props.getStudentFee}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(FeeFormBody));
